<template>
  <div class="news-container">
    <div class="news-top">
      <div class="news-title">{{ menu.module_name }}</div>
      <div class="news-type-list">
        <div
          class="news-type-item"
          :class="{ active: item.id == classifyId }"
          v-for="item in classifyList"
          @click="searchCourseList(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="news-content">
      <template v-if="newsList.length > 0">
        <transition name="fade">
          <div
            class="news-detail"
            v-if="mainRecommendNews"
            @click="showNewsDetail(mainRecommendNews)"
          >
            <div class="news-date">
              {{ $utils.formatDate(mainRecommendNews.publish_time, 'MM-DD') }}
            </div>
            <div class="news-title">{{ mainRecommendNews.news_name }}</div>
            <div
              class="news-content-text"
              v-html="$utils.getContentText(mainRecommendNews.context)"
            ></div>
            <div class="news-content-img">
              <img :src="mainRecommendNews.news_cover_url" alt="" />
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="news-list" v-if="newsList.length > 0">
            <div class="news-item" v-for="item in newsList" @click="showNewsDetail(item)">
              <div class="item-top">
                <div class="item-title">{{ item.news_name }}</div>
                <div class="item-date">{{ $utils.formatDate(item.publish_time, 'MM-DD') }}</div>
              </div>
              <div class="item-content">
                <div class="content-text" v-html="$utils.getContentText(item.context)"></div>
                <div class="content-img">
                  <!-- <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/1e402c3c4c5140e88531374171ec03c5.png"/> -->
                </div>
              </div>
              <div class="bottom-line"></div>
            </div>
          </div>
        </transition>
      </template>
      <div v-else class="no-data">
        <Empty text="暂无新闻动态" />
      </div>
    </div>
    <div class="btn-container">
      <div class="more-btn" @click="handleMore" v-if="newsList && newsList.length > 0">
        <span class="text">查看更多</span>
        <div class="icon-container">
          <div class="icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Empty } from 'zhs-components'
import { getStorage } from '@/plugins/store'
import { handleLogin } from '@/plugins/utils'

export default {
  props: {
    menu: Object,
    zhsRole: Number
  },
  components: {
    Empty
  },
  created() {
    this.getNewsClassifyList()
  },
  watch: {
    classifyId: {
      handler(val) {
        this.getNewsList()
      },
      immediate: true
    }
  },
  data() {
    return {
      newsList: [],
      mainRecommendNews: null,
      classifyList: [],
      classifyId: '',
      hiddenMoreClass: true
    }
  },
  computed: {
    schoolId() {
      const res = getStorage('projectBaseData')
      return res.school_id ? res.school_id : 0
    }
  },
  methods: {
    handleLogin,
    showNewsDetail(item) {
      if (this.schoolId == 795) {
        const scope = item.scope || 0
        // 未登录状态下，选择非公开范围时，阻止切换并跳转登录
        if (scope > 0 && this.zhsRole == 0) {
          this.handleLogin()
          return false // 阻止切换
        }
        // 角色为老师时,选择学生可见时，阻止切换
        if (scope == 2 && this.zhsRole == 2) {
          ElMessage.warning('该记录仅学生可访问，请查看其他内容')
          return false // 阻止切换
        }
        // 角色为学生时,选择老师可见时，阻止切换
        if (scope == 1 && this.zhsRole == 3) {
          ElMessage.warning('该记录仅教师可访问，请查看其他内容')
          return false // 阻止切换
        }
      }
      if (item.news_type === 1) {
        window.location.href = `/noticeDetail.html?id=${item.id}&menuId=${this.menu.menu_id}&name=${this.menu.module_name}`
      } else {
        this.addViewCount(item.id)
        window.open(item.news_url)
      }
    },
    handleMore() {
      window.open(`/notice.html?type=1&name=${this.menu.module_name}&menuId=${this.menu.menu_id}`)
    },
    // 增加观看次数
    async addViewCount(id) {
      const res = await this.$http.addViewCount(
        {
          id
        },
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      )
      console.log('count', res)
    },
    handleLookDetail(item) {
      if (item.news_type === 1) {
        window.location.href = `/noticeDetail.html?type=1&id=${item.id}&name=${this.menu.module_name}&menuId=${this.menu.menu_id}`
      } else {
        this.addViewCount(item.id)
        window.open(item.news_url)
      }
    },
    async getNewsList() {
      this.mainRecommendNews = null
      const res =
        (await this.$http.getHomeNews({
          num: this.menu.num,
          menu_id: this.menu.menu_id,
          classify_id: this.classifyId
        })) || []
      this.mainRecommendNews = res[0]
      this.newsList = res
    },
    async getNewsClassifyList() {
      const res = await this.$http.getNewsClassify({
        menu_id: this.menu.menu_id
      })
      this.classifyList = res
      this.classifyList.unshift({ id: '', name: '全部' })
      // if (res && res.length) {
      //   this.classifyId = res[0].id
      // }
      console.log('getNewsClassifyList', this.classifyList)
    },
    searchCourseList(id) {
      this.classifyId = id
      // this.getNewsList();
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  background-color: #fff;
  padding: 40px 80px;
  box-sizing: border-box;
  width: 1440px;
  .news-top {
    display: flex;
    justify-content: space-between;
    .news-title {
      color: #1c212a;
      font-family: 'Alibaba PuHuiTi';
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
    .news-type-list {
      display: flex;
      .news-type-item {
        width: 112px;
        height: 40px;
        background-color: #f7f8fa;
        color: #1d2129;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        line-height: 40px;
        margin-left: 28px;
        border-radius: 6px;
        cursor: pointer;
        &:hover {
          color: #194189;
        }
        &.active {
          background-color: #194189;
          color: #fff;
        }
      }
    }
  }
  .news-content {
    display: flex;
    width: 100%;
    .fade-enter-active,
    .fade-leave-active {
      transition: all 0.5s ease;
    }
    .fade-enter-from {
      opacity: 0;
    }
    .fade-enter-to {
      opacity: 1;
    }
    .fade-leave-from {
      opacity: 1;
    }
    .fade-leave-to {
      opacity: 0;
    }
    .news-detail {
      width: 616px;
      padding: 24px;
      border-radius: 16px;
      background: linear-gradient(0deg, #f7f8fa 0%, #f7f8fa 100%),
        linear-gradient(180deg, #d7efff 0%, #d6efff 100%);
      margin-top: 40px;
      cursor: pointer;
      // &:hover {
      //   img {
      //     transform: scale(1.05);
      //   }
      // }
      .news-date {
        color: #1c212a;
        font-family: 'DIN Alternate';
        font-size: 32px;
        font-weight: 700;
      }
      .news-title {
        color: #1c212a;
        font-family: 'PingFang SC';
        font-size: 24px;
        font-weight: 500;
        width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 28px;
      }
      .news-content-text {
        margin: 20px 0;
        color: #86909c;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        width: 100%;
        height: 40px;
        overflow: hidden;
        text-indent: 4px;
        &.show-more {
          height: 100%;
          overflow: visible;
        }
      }
      .news-content-img {
        width: 100%;
        height: 332px;
        img {
          transition: all 0.5s ease;
          height: 100%;
          width: 100%;
          border-radius: 12px;
        }
      }
    }
    .news-list {
      width: 636px;
      margin-top: 40px;
      margin-left: 28px;
      .news-item {
        width: 100%;
        margin-bottom: 30px;
        border-bottom: 1px solid rgba(29, 33, 41, 0.08);
        cursor: pointer;
        position: relative;
        .bottom-line {
          height: 1px;
          width: 0;
          background-color: #194189;
          position: absolute;
          left: 0;
          bottom: 0;
        }
        &:last-child {
          border-bottom: none;
          .bottom-line {
            display: none;
          }
        }
        &:hover {
          .bottom-line {
            transition: all 0.5s;
            width: 100%;
          }
          .item-top {
            .item-title {
              color: #194189;
              &::before {
                background: #194189;
              }
            }
            .item-date {
              color: #194189;
            }
          }
          .item-content {
            .content-text {
              color: #194189;
            }
            .content-img {
              img {
                display: block;
              }
            }
          }
        }
        .item-top {
          display: flex;
          justify-content: space-between;
          .item-title {
            overflow: hidden;
            color: #1c212a;
            text-overflow: ellipsis;
            font-size: 20px;
            font-weight: 500;
            width: 60%;
            white-space: nowrap;
            position: relative;
            padding-left: 16px;
            &::before {
              content: '';
              display: block;
              width: 8px;
              height: 8px;
              background: #194189;
              border-radius: 50%;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0px;
            }
          }
          .item-date {
            color: #1c212a;
            font-family: 'DIN Alternate';
            font-size: 24px;
            font-weight: 700;
          }
        }
        .item-content {
          margin-top: 20px;
          margin-bottom: 28px;
          display: flex;
          .content-text {
            color: #86909c;
            line-height: 20px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            width: 100%;
            height: 40px;
            overflow: hidden;
            text-indent: 4px;
            font-size: 14px;
          }
          .content-img {
            height: 28px;
            width: 104px;
            padding-left: 27px;
            img {
              height: 28px;
              width: 28px;
              display: none;
            }
          }
        }
      }
    }
    .no-data {
      height: 518px;
    }
  }
  .btn-container {
    display: flex;
    justify-content: center;
    .more-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 48px;
      border: 1px solid #1d2129;
      border-radius: 6px;
      margin-top: 28px;
      cursor: pointer;
      &:hover {
        border-color: #194189;
        span {
          color: #194189;
        }
        .icon-container {
          .icon {
            animation: btnFadeIn 0.2s ease-in-out;
            background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/fe207a0f99cb41778f240046e6e39454.png');
          }
        }
      }
      span {
        color: #1d2129;
        font-size: 16px;
        font-weight: 500;
      }
      .icon-container {
        width: 32px;
        height: 32px;
        .icon {
          width: 100%;
          height: 100%;
          background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/7d4b70c240b44e8d9844754f33039606.png');
          background-size: 100% 100%;
        }
      }
    }
  }
  @keyframes btnFadeIn {
    0% {
      opacity: 0;
      width: 0;
      height: 100%;
    }
    100% {
      opacity: 1;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
